/**
 * Outlined "document with an X" icon used to denote a failed submission on an
 * order (e.g. the error state shown in the Auth Status column).
 *
 * @param props.width - SVG width (defaults to `16`).
 * @param props.height - SVG height (defaults to `16`).
 * @param props.stroke - Stroke color for the glyph (defaults to red `#F50400`).
 * @returns The rendered file-x SVG icon.
 */
const FileXIcon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "16"}
    height={props.height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_file_x_icon)">
      <path
        d="M9.33073 7.33203H5.33073M6.66406 9.9987H5.33073M10.6641 4.66536H5.33073M13.3307 7.9987V4.53203C13.3307 3.41193 13.3307 2.85187 13.1127 2.42405C12.921 2.04773 12.615 1.74176 12.2387 1.55002C11.8109 1.33203 11.2508 1.33203 10.1307 1.33203H5.86406C4.74396 1.33203 4.1839 1.33203 3.75608 1.55002C3.37976 1.74176 3.0738 2.04773 2.88205 2.42405C2.66406 2.85187 2.66406 3.41193 2.66406 4.53203V11.4654C2.66406 12.5855 2.66406 13.1455 2.88205 13.5733C3.0738 13.9497 3.37976 14.2556 3.75608 14.4474C4.1839 14.6654 4.74396 14.6654 5.86406 14.6654H7.9974M10.6641 10.6654L13.9974 13.9987M13.9974 10.6654L10.6641 13.9987"
        stroke={props.stroke || "#F50400"}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_file_x_icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FileXIcon;
